import styled from 'styled-components';

export const OnboardingIntroductionContainer = styled.div`
  width: 100%;
  max-width: 550px;
  margin-top: 100px;
  display: flex;
  flex-direction: column;

  img {
    margin-bottom: 12px;
  }
`;

export const OnboardingIntroductionContent = styled.div`
  text-align: justify;
  color: ${({ theme }) => theme.colors.textPrimarySecondary1100};
  margin-top: 10px;
`;

export const SubmitButtonContainer = styled.div`
  width: 50%;
`;

export const OnboardingFooter = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const ContentList = styled.ul`
  padding-left: 24px;
  list-style: none;
`;

export const ContentItem = styled.li`
  font-size: medium;
  font-weight: 100;
  margin-bottom: 20px;
`;

export const MultipleAgreementContainer = styled.div`
  margin-top: 20px;
  margin-bottom: 40px;
  padding-left: 24px;

  fieldset[role='radiogroup'] {
    display: flex;
    flex-direction: column;
    gap: 18px;

    span {
      font-weight: 300;
    }

    svg {
      path:last-child {
        fill: ${({ theme }) => theme.colors.buttonButtonPrimarySecondary2100};
      }
    }
  }
`;
